import { render, staticRenderFns } from "./people_asset.vue?vue&type=template&id=2e5349bc&scoped=true"
import script from "./people_asset.vue?vue&type=script&lang=js"
export * from "./people_asset.vue?vue&type=script&lang=js"
import style0 from "./people_asset.vue?vue&type=style&index=0&id=2e5349bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5349bc",
  null
  
)

export default component.exports